
import Vue, { ref } from 'vue';
import PasswordResetService from '@/services/PasswordResetService';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import LRPopup from '@/components/login-register/LRPopup.vue';
import { useRouter } from 'vue2-helpers/vue-router';
import { useSessionStorage, useTimeout } from '@vueuse/core';
import { PASSWORD_RESET_RESEND_INTERVAL } from '@/models/ResendTimout';

export default Vue.extend({
  name: 'PasswordResetConfirmation',
  components: { LRPopup, BCXMarkdown },
  setup() {
    const router = useRouter();
    const resent = ref(false);
    const resending = ref(false);
    const resendError = ref(false);
    const showConfirm = ref(false);
    const isConfirmed = ref(false);
    // Cooldown so the just-sent email can't be re-requested immediately.
    const { ready: canResend, start: startResendInterval } = useTimeout(PASSWORD_RESET_RESEND_INTERVAL, { controls: true });

    const email = useSessionStorage('passwordResetEmail', '');

    const resend = () => {
      if (!isConfirmed.value) {
        if (!canResend.value || resending.value) return;
        showConfirm.value = true;
        return;
      }
      isConfirmed.value = false;
      resending.value = true;
      resent.value = false;
      resendError.value = false;
      PasswordResetService.resendEmail(email.value)
        .then(() => {
          resent.value = true;
          startResendInterval();
        })
        .catch(() => {
          resendError.value = true;
        })
        .finally(() => {
          resending.value = false;
        });
    };

    const onConfirmed = (is:boolean) => {
      isConfirmed.value = is;
      if (is) resend();
      else {
        router.push({ name: 'password-reset' });
      }
    };

    return {
      resent,
      resending,
      resendError,
      canResend,
      email,
      resend,
      onConfirmed,
      showConfirm
    };
  },
});
